/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initRebuyCart() {
    document.addEventListener("rebuy:smartcart.ready", (e) => {
      const cart = e.detail.smartcart.cart;
      showPaymentIcons();
      freeShippingLimit(cart);
    });
  
    document.addEventListener("rebuy:cart.change", (e) => {
      const cart = e.detail.cart.cart;
      showPaymentIcons();
      freeShippingLimit(cart);
    });
  }
  
  function showPaymentIcons() {
    setTimeout(() => {
      const paymentIcons = document.querySelector(".cart__drawer__payment__icons");
      console.log(paymentIcons, "paymentIcons");
      const checkoutArea = document.querySelector('div[data-rebuy-component="checkout-area"]');
  
      if (!paymentIcons || !checkoutArea || checkoutArea.querySelector(".cloned-payment-icons")) {
        return;
      }
  
      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      clonedPaymentIcons.classList.add("cloned-payment-icons"); 
      checkoutArea.appendChild(clonedPaymentIcons);
    }, 500);
  }

  initRebuyCart();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
